






















































import '../../styles/proposal-tile.css'
import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  data() {
    return {
      usePlaceholder: false,
    }
  },
  props: {
    isDocument: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    updatedAt: {
      type: Date,
      required: false,
    },
    createdAt: {
      type: Date,
      required: false,
    },
    documentsCount: {
      type: Number,
      required: false,
      default: 0,
    },
    imageUrl: {
      type: String,
      required: false,
    },
  },
  mounted: async function () {
    try {
      const canLoadImage = await fetch(this.imageUrl)

      if (!canLoadImage.ok) this.usePlaceholder = true
    } catch {
      this.usePlaceholder = true
    }
  },
  methods: {
    formatDate: (date: string) => moment(date).format('MMM. DD YYYY'),
  },
  name: 'ProposalTile',
})
